import { Link } from 'react-router-dom';

/**
 * One line of links to the legal documents, for the foot of a page.
 *
 * The acceptance gate deliberately does not use this — it needs the links in a
 * sentence, opening in a new tab so reading them does not unmount the gate.
 */
export function LegalLinks() {
  return (
    <p className="legal-links">
      <Link to="/privacy">Privacy</Link>
      <span aria-hidden="true"> · </span>
      <Link to="/terms">Terms</Link>
    </p>
  );
}
